import { TableHoverActions } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Product } from '@features/products/types/product'

import { ProductsTableHoverActionHandler } from './types/productsTableHoverActionHandler'

export interface ProductsTableHoverActionsProps {
  selectedProduct: Product
  onEditProductClick?: ProductsTableHoverActionHandler
  onDuplicateProductClick?: ProductsTableHoverActionHandler
  onDeleteProductClick?: ProductsTableHoverActionHandler
}

export const ProductsTableHoverActions = ({
  selectedProduct,
  onDeleteProductClick,
  onDuplicateProductClick,
  onEditProductClick,
}: ProductsTableHoverActionsProps) => {
  const { t } = useTranslation()

  const handleEditProductClick = useCallback(
    () => onEditProductClick?.(selectedProduct),
    [onEditProductClick, selectedProduct],
  )

  const handleDuplicateProductClick = useCallback(
    () =>
      onDuplicateProductClick?.({
        ...selectedProduct,
        name: t('products.table.actions.duplicated_name', { name: selectedProduct.name.trim() }),
      }),
    [onDuplicateProductClick, selectedProduct, t],
  )

  const handleDeleteProductClick = useCallback(
    () => onDeleteProductClick?.(selectedProduct),
    [onDeleteProductClick, selectedProduct],
  )

  return (
    <TableHoverActions>
      <TableHoverActions.Item
        icon="squarePen"
        label={t('products.table.actions.edit')}
        onClick={handleEditProductClick}
      />
      <TableHoverActions.Item
        icon="copy"
        label={t('products.table.actions.duplicate')}
        onClick={handleDuplicateProductClick}
      />
      <TableHoverActions.Item
        icon="trash"
        label={t('products.table.actions.delete')}
        onClick={handleDeleteProductClick}
      />
    </TableHoverActions>
  )
}
